/**
 * Silhouette SVG de secours quand aucune photo n'est choisie — portée depuis
 * les fichiers de référence (menu-templates.html `portrait(bg, fg)` 4:5 et
 * menu-grand-format.html `portrait(bg, fg)` carré). `shape` sélectionne le
 * viewBox : "portrait" (4:5, petit format) ou "square" (grand format).
 */
export function PortraitPlaceholder({
  bg,
  fg,
  label = "SA PHOTO",
  shape = "portrait",
}: {
  bg: string;
  fg: string;
  label?: string;
  shape?: "portrait" | "square";
}) {
  const common = {
    preserveAspectRatio: "xMidYMid slice" as const,
    role: "img" as const,
    "aria-label": "Emplacement photo",
    style: { display: "block", width: "100%", height: "100%" },
  };
  if (shape === "square") {
    return (
      <svg viewBox="0 0 100 100" {...common}>
        <rect width="100" height="100" fill={bg} />
        <circle cx="50" cy="40" r="17" fill={fg} />
        <path d="M16 100 Q16 66 50 66 Q84 66 84 100 Z" fill={fg} />
        <text
          x="50"
          y="94"
          textAnchor="middle"
          fontFamily="Helvetica, Arial, sans-serif"
          fontSize="5.5"
          letterSpacing="1.4"
          fill={bg}
        >
          {label}
        </text>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 100 120" {...common}>
      <rect width="100" height="120" fill={bg} />
      <circle cx="50" cy="44" r="19" fill={fg} />
      <path d="M14 120 Q14 82 50 82 Q86 82 86 120 Z" fill={fg} />
      <text
        x="50"
        y="112"
        textAnchor="middle"
        fontFamily="Helvetica, Arial, sans-serif"
        fontSize="6"
        letterSpacing="1.5"
        fill={bg}
      >
        {label}
      </text>
    </svg>
  );
}
